export default __webpack_public_path__ + "static/media/Portfolio.5d970d4b.png";